{
  "accessibility": 61696,
  "accessibility-inset": 61697,
  "ai-model": 62022,
  "alert": 61698,
  "alert-fill": 61699,
  "apps": 61700,
  "archive": 61701,
  "arrow-both": 61702,
  "arrow-down": 61703,
  "arrow-down-left": 61704,
  "arrow-down-right": 61705,
  "arrow-left": 61706,
  "arrow-right": 61707,
  "arrow-switch": 61708,
  "arrow-up": 61709,
  "arrow-up-left": 61710,
  "arrow-up-right": 61711,
  "beaker": 61712,
  "bell": 61713,
  "bell-fill": 61714,
  "bell-slash": 61715,
  "blocked": 61716,
  "bold": 61717,
  "book": 61718,
  "bookmark": 61719,
  "bookmark-filled": 62017,
  "bookmark-slash": 61720,
  "bookmark-slash-fill": 62018,
  "briefcase": 61721,
  "broadcast": 61722,
  "browser": 61723,
  "bug": 61724,
  "cache": 61725,
  "calendar": 61726,
  "check": 61727,
  "check-circle": 61728,
  "check-circle-fill": 61729,
  "checkbox": 61730,
  "checklist": 61731,
  "chevron-down": 61732,
  "chevron-left": 61733,
  "chevron-right": 61734,
  "chevron-up": 61735,
  "circle": 61736,
  "circle-slash": 61737,
  "clock": 61738,
  "clock-fill": 61739,
  "cloud": 61740,
  "cloud-offline": 61741,
  "code": 61742,
  "code-of-conduct": 61743,
  "code-review": 61744,
  "code-square": 61745,
  "codescan": 61746,
  "codescan-checkmark": 61747,
  "codespaces": 61748,
  "columns": 61749,
  "command-palette": 61750,
  "comment": 61751,
  "comment-discussion": 61752,
  "container": 61753,
  "copilot": 61754,
  "copilot-error": 61755,
  "copilot-warning": 61756,
  "copy": 61757,
  "cpu": 61758,
  "credit-card": 61759,
  "cross-reference": 61760,
  "dash": 61761,
  "database": 61762,
  "dependabot": 61763,
  "desktop-download": 61764,
  "device-camera": 61765,
  "device-camera-video": 61766,
  "device-desktop": 61767,
  "device-mobile": 61768,
  "devices": 61769,
  "diamond": 61770,
  "diff": 61771,
  "diff-added": 61772,
  "diff-ignored": 61773,
  "diff-modified": 61774,
  "diff-removed": 61775,
  "diff-renamed": 61776,
  "discussion-closed": 61777,
  "discussion-duplicate": 61778,
  "discussion-outdated": 61779,
  "dot": 61780,
  "dot-fill": 61781,
  "download": 61782,
  "duplicate": 61783,
  "ellipsis": 61784,
  "eye": 61785,
  "eye-closed": 61786,
  "feed-discussion": 61787,
  "feed-forked": 61788,
  "feed-heart": 61789,
  "feed-issue-closed": 61790,
  "feed-issue-draft": 61791,
  "feed-issue-open": 61792,
  "feed-issue-reopen": 61793,
  "feed-merged": 61794,
  "feed-person": 61795,
  "feed-plus": 61796,
  "feed-public": 61797,
  "feed-pull-request-closed": 61798,
  "feed-pull-request-draft": 61799,
  "feed-pull-request-open": 61800,
  "feed-repo": 61801,
  "feed-rocket": 61802,
  "feed-star": 61803,
  "feed-tag": 61804,
  "feed-trophy": 61805,
  "file": 61806,
  "file-added": 61807,
  "file-badge": 61808,
  "file-binary": 61809,
  "file-code": 61810,
  "file-diff": 61811,
  "file-directory": 61812,
  "file-directory-fill": 61813,
  "file-directory-open-fill": 61814,
  "file-directory-symlink": 61815,
  "file-media": 62019,
  "file-moved": 61816,
  "file-removed": 61817,
  "file-submodule": 61818,
  "file-symlink-file": 61819,
  "file-zip": 61820,
  "filter": 61821,
  "filter-remove": 61822,
  "fiscal-host": 61823,
  "flame": 61824,
  "fold": 61825,
  "fold-down": 61826,
  "fold-up": 61827,
  "gear": 61828,
  "gift": 61829,
  "git-branch": 61830,
  "git-commit": 61831,
  "git-compare": 61832,
  "git-merge": 61833,
  "git-merge-queue": 61834,
  "git-pull-request": 61835,
  "git-pull-request-closed": 61836,
  "git-pull-request-draft": 61837,
  "globe": 61838,
  "goal": 61839,
  "grabber": 61840,
  "graph": 61841,
  "hash": 61842,
  "heading": 61843,
  "heart": 61844,
  "heart-fill": 61845,
  "history": 61846,
  "home": 61847,
  "home-fill": 62020,
  "horizontal-rule": 61848,
  "hourglass": 61849,
  "hubot": 61850,
  "id-badge": 61851,
  "image": 61852,
  "inbox": 61853,
  "infinity": 61854,
  "info": 61855,
  "issue-closed": 61856,
  "issue-draft": 61857,
  "issue-opened": 61858,
  "issue-reopened": 61859,
  "issue-tracked-by": 61860,
  "issue-tracks": 61861,
  "italic": 61862,
  "iterations": 61863,
  "kebab-horizontal": 61864,
  "key": 61865,
  "key-asterisk": 61866,
  "law": 61867,
  "light-bulb": 61868,
  "link": 61869,
  "link-external": 61870,
  "list-ordered": 61871,
  "list-unordered": 61872,
  "location": 61873,
  "lock": 61874,
  "log": 61875,
  "logo-gist": 61876,
  "logo-github": 61877,
  "mail": 61878,
  "mark-github": 61879,
  "markdown": 61880,
  "megaphone": 61881,
  "mention": 61882,
  "meter": 61883,
  "milestone": 61884,
  "mirror": 61885,
  "moon": 61886,
  "mortar-board": 61887,
  "move-to-bottom": 61888,
  "move-to-end": 61889,
  "move-to-start": 61890,
  "move-to-top": 61891,
  "multi-select": 61892,
  "mute": 61893,
  "no-entry": 61894,
  "north-star": 61895,
  "note": 61896,
  "number": 61897,
  "organization": 61898,
  "package": 61899,
  "package-dependencies": 61900,
  "package-dependents": 61901,
  "paintbrush": 61902,
  "paper-airplane": 61903,
  "paperclip": 61904,
  "passkey-fill": 61905,
  "paste": 61906,
  "pause": 62025,
  "pencil": 61907,
  "people": 61908,
  "person": 61909,
  "person-add": 61910,
  "person-fill": 61911,
  "pin": 61912,
  "pin-slash": 61913,
  "pivot-column": 61914,
  "play": 61915,
  "plug": 61916,
  "plus": 61917,
  "plus-circle": 61918,
  "project": 61919,
  "project-roadmap": 61920,
  "project-symlink": 61921,
  "project-template": 61922,
  "pulse": 61923,
  "question": 61924,
  "quote": 61925,
  "read": 61926,
  "redo": 61927,
  "rel-file-path": 61928,
  "reply": 61929,
  "repo": 61930,
  "repo-clone": 61931,
  "repo-deleted": 61932,
  "repo-forked": 61933,
  "repo-locked": 61934,
  "repo-pull": 61935,
  "repo-push": 61936,
  "repo-template": 61937,
  "report": 61938,
  "rocket": 61939,
  "rows": 61940,
  "rss": 61941,
  "ruby": 61942,
  "screen-full": 61943,
  "screen-normal": 61944,
  "search": 61945,
  "server": 61946,
  "share": 61947,
  "share-android": 61948,
  "shield": 61949,
  "shield-check": 61950,
  "shield-lock": 61951,
  "shield-slash": 61952,
  "shield-x": 61953,
  "sidebar-collapse": 61954,
  "sidebar-expand": 61955,
  "sign-in": 61956,
  "sign-out": 61957,
  "single-select": 61958,
  "skip": 61959,
  "skip-fill": 61960,
  "sliders": 61961,
  "smiley": 61962,
  "sort-asc": 61963,
  "sort-desc": 61964,
  "sparkle": 62026,
  "sparkle-fill": 61965,
  "sparkles-fill": 62023,
  "sponsor-tiers": 61966,
  "square": 61967,
  "square-circle": 62024,
  "square-fill": 61968,
  "squirrel": 61969,
  "stack": 61970,
  "star": 61971,
  "star-fill": 61972,
  "stop": 61973,
  "stopwatch": 61974,
  "strikethrough": 61975,
  "sun": 61976,
  "sync": 61977,
  "tab": 62021,
  "tab-external": 61978,
  "table": 61979,
  "tag": 61980,
  "tasklist": 61981,
  "telescope": 61982,
  "telescope-fill": 61983,
  "terminal": 61984,
  "three-bars": 61985,
  "thumbsdown": 61986,
  "thumbsup": 61987,
  "tools": 61988,
  "tracked-by-closed-completed": 61989,
  "tracked-by-closed-not-planned": 61990,
  "trash": 61991,
  "triangle-down": 61992,
  "triangle-left": 61993,
  "triangle-right": 61994,
  "triangle-up": 61995,
  "trophy": 61996,
  "typography": 61997,
  "undo": 61998,
  "unfold": 61999,
  "unlink": 62000,
  "unlock": 62001,
  "unmute": 62002,
  "unread": 62003,
  "unverified": 62004,
  "upload": 62005,
  "verified": 62006,
  "versions": 62007,
  "video": 62008,
  "webhook": 62009,
  "workflow": 62010,
  "x": 62011,
  "x-circle": 62012,
  "x-circle-fill": 62013,
  "zap": 62014,
  "zoom-in": 62015,
  "zoom-out": 62016
}